import React, { useEffect, useState } from 'react';
import { getTableTopTile } from '@reducers/tableTop';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Loader from '@components/common/Loader';
import { LABEL, CUSTOM_MESSAGES } from '../../veriables';
import { getObjectValue } from '@utility/utills';
import { APP_CONFIG, COUNTRY_CODE } from '@constants';
import ReceiptScreen from '@components/ReceiptScreen';
import { setNotification } from '@reducers/notification';
import Tiles from '@components/Tiles';
import {
  openEmployeeCheck,
  logout,
  setInActivityStatus,
} from '@reducers/oauth';
import EmployeeCheck from '@components/checksCommon/employeeCheck';
import {
  setSeat,
  clearCart,
  pushCartItems,
  setPaymentCheck,
  removePaymentCheck,
  removePosition,
  priceCheck,
  getOrderMenus,
} from '@reducers/orders';
import { isEmpty } from 'lodash';
import { clearAuthResponse } from '@reducers/payment';
import { checkOpen, occupySeat, callServer } from '@reducers/checks';
import {
  updateChecksAfterResponse,
  sendChecks,
  updateCheckAfterPriceCheck,
} from '@reducers/storeChecks';
import cn from 'classnames';
import KioskConfirmatioPopUp from '@components/checksCommon/kioskConfirmationPopUp';
import EventEmitter from '@utility/eventSubscribers';
import { flowType } from '@utility/userInfo';

const TableTopLandingPage = props => {
  const [isConfirmation, setIsConfirmation] = useState(false);
  const [isSuccessCallServer, setIsSuccessCallServer] = useState(false);
  const { auth, seat, tileTypes } = props;
  const [checkHeaderObject, setCheckHeaderObject] = useState(null);
  const currenySymbol = LABEL().CURRENCY_SYMBOL;
  const countryCode = getObjectValue(
    () => COUNTRY_CODE[props.auth.country].dialCode,
    '1'
  );
  const checkName = getObjectValue(
    () => window.sessionStorage.getItem('checkName'),
    ''
  );
  const isDefaultMode = getObjectValue(
    () =>
      !props.deviceInfo.deviceGroup ||
      [0].includes(props.deviceInfo.deviceGroup.startMode),
    false
  );
  const isOrderPayMode = getObjectValue(
    () => [1].includes(props.deviceInfo.deviceGroup.startMode),
    false
  );
  const isPaymentMode = getObjectValue(
    () => [2].includes(props.deviceInfo.deviceGroup.startMode),
    false
  );
  const isOrderOnlyMode = getObjectValue(
    () => [3].includes(props.deviceInfo.deviceGroup.startMode),
    false
  );
  useEffect(() => {
    const checkObject =
      props.tableData && Object.values(props.tableData)
        ? Object.values(props.tableData).find(
            b =>
              b.open &&
              (checkName === b.stationName || checkName === b.stationNumber)
          )
        : null;
    setCheckHeaderObject(checkObject);
  }, [props.tableData]);

  useEffect(() => {
    if (window.ReactNativeWebView) {
      EventEmitter.enableSideBar(false);
    }
    props.clearAuthResponse();
    props.removePaymentCheck();
    if (auth) {
      props.getTableTopTile(auth.id).catch(err => {
        props.setNotification({
          type: 'danger',
          message: err.message,
        });
      });
    }
  }, [auth]);
  const pendingItems =
    checkHeaderObject && checkHeaderObject.orders && checkHeaderObject.orders[0]
      ? checkHeaderObject.orders[0].items.reduce((a, v) => {
          if (v.pending) {
            a.push({
              ...v,
              ...JSON.parse(v.orderJson),
              ...JSON.parse(JSON.parse(v.orderJson).modifierJson),
            });
          }
          return a;
        }, [])
      : [];
  const renderModifier = modifiersObj => (
    <div className={cn('pl-2')}>
      {modifiersObj &&
        modifiersObj.map(modifier => {
          if (
            modifier.modifiers &&
            modifier.modifiers.length === 1 &&
            getObjectValue(() => !modifier.modifiers[0].modifierGroupId, false)
          ) {
            return (
              <div key={modifier.id} className="fs-14 fw-500">
                {modifier.modifiers[0].quantity > 1 && (
                  <span className={cn('badge badge-warning ml-1 va-tt')}>
                    {modifier.modifiers[0].quantity} &times;
                  </span>
                )}
                {modifier.modifierName}
                {modifier.quantity > 1 && (
                  <span className="badge badge-warning ml-1 va-tt">
                    &times; {modifier.quantity}
                  </span>
                )}
                {modifier.price ? (
                  <small className="text-muted od-text-muted ml-1">
                    {LABEL().CURRENCY_SYMBOL}
                    {modifier.price.toFixed(2)}
                  </small>
                ) : (
                  ''
                )}
              </div>
            );
          }
          return (
            <div key={modifier.id} className="fs-14 fw-500">
              {modifier.quantity > 1 && (
                <span className={cn('badge badge-warning ml-1 va-tt')}>
                  {modifier.quantity} &times;
                </span>
              )}
              {modifier.modifierName}
              {modifier.price ? (
                <small className="text-muted od-text-muted ml-1">
                  {LABEL().CURRENCY_SYMBOL}
                  {modifier.price.toFixed(2)}
                </small>
              ) : (
                ''
              )}
              {(modifier.note || modifier.comment) && (
                <div className="pl-2">{modifier.note || modifier.comment}</div>
              )}
              {modifier.modifiers &&
                modifier.modifiers.length > 0 &&
                renderModifier(modifier.modifiers)}
            </div>
          );
        })}
    </div>
  );

  const handleRouteToCheckListing = () => {
    props.openEmployeeCheck();
  };

  const getSubTotalAmount = table => {
    return props.auth.country === 1 ? +table.itemAmount : +table.subTotalAmount;
  };

  const getTotalAmount = table => {
    const discount = getObjectValue(() => table.discountAmount, 0);
    const serviceCharge = getObjectValue(() => table.serviceChargeAmount, 0);
    return props.auth.country === 1
      ? +(table.itemAmount + table.taxAmount + serviceCharge - discount)
      : +(table.itemAmount - discount);
  };

  const speedOrderRouteToPay = () => {
    const data = getObjectValue(
      () =>
        checkHeaderObject.orders[0].items.reduce((a, v) => {
          if (v.pending) {
            a.push({
              ...v,
              ...JSON.parse(v.orderJson),
              menuScreenId: getObjectValue(
                () => JSON.parse(JSON.parse(v.orderJson).menuScreenId),
                0
              ),
              menuId: getObjectValue(
                () => JSON.parse(JSON.parse(v.orderJson).menuId),
                0
              ),
            });
          }
          return a;
        }, []),
      []
    );
    const combinedData = [...checkHeaderObject.items, ...data];
    if (combinedData && combinedData.length > 0) {
      let subtotalAmount = 0;
      const items = combinedData.map(e => {
        subtotalAmount += e.price;
        return {
          menuItemId: e.menuItemId,
          quantity: e.quantity,
          modifiers: e.modifiers,
          price: e.price,
          note: e.note,
          menuScreenId: e.menuScreenId,
          menuId: e.menuId,
        };
      });
      const dataToSend = {
        deviceId: props.deviceInfo.deviceId,
        employeeId: Number(props.userInfo.id),
        storeId: props.deviceInfo.storeId,
        checkHeaderId: checkHeaderObject.id,
        items,
        subtotalAmount,
      };
      props
        .priceCheck(dataToSend)
        .then(resData => {
          props.setSeat({
            ...checkHeaderObject,
            ...resData,
            items: combinedData,
            itemAmount: resData.subTotalAmount,
            totalAmount: getTotalAmount({
              ...resData,
              itemAmount: resData.subTotalAmount,
            }),
          });
          props.updateCheckAfterPriceCheck({
            ...checkHeaderObject,
            ...resData,
          });
          props
            .setPaymentCheck({
              ...checkHeaderObject,
              ...resData,
              items: combinedData,
              itemAmount: resData.subTotalAmount,
              totalAmount: getTotalAmount({
                ...resData,
                itemAmount: resData.subTotalAmount,
              }),
            })
            .then(() => {
              props.history.replace({
                pathname: `${APP_CONFIG.BASE_URL}/receipt/${checkHeaderObject.id}?ticketSplitTypeId=1&splitValue=1&screenType=1`,
              });
            });
        })
        .catch(err => {
          props.setNotification({
            type: 'danger',
            message: err.message,
          });
        });
    } else {
      props.setNotification({
        message: CUSTOM_MESSAGES().NO_ITEM_MSG,
        type: 'danger',
      });
    }
  };

  const payRoute = () => {
    if (pendingItems.length > 0 && isDefaultMode) {
      props.setNotification({
        message: CUSTOM_MESSAGES().PAYMENT_ERROR_HAVING_UNSENT,
        type: 'danger',
      });
    } else {
      props.setSeat({
        ...checkHeaderObject,
        subTotalAmount: getSubTotalAmount(checkHeaderObject),
        totalAmount: getTotalAmount(checkHeaderObject),
      });
      props
        .setPaymentCheck({
          ...checkHeaderObject,
          subTotalAmount: getSubTotalAmount(checkHeaderObject),
          totalAmount: getTotalAmount(checkHeaderObject),
        })
        .then(() => {
          props.history.replace({
            pathname: `${APP_CONFIG.BASE_URL}/receipt/${checkHeaderObject.id}?ticketSplitTypeId=1&splitValue=1&screenType=1`,
          });
        });
    }
  };

  const goToOrder = () => {
    const data = { ...checkHeaderObject };
    props.setSeat(data).then(() => {
      props.removePosition();
      props.clearCart().then(() => {
        const cartItems = getObjectValue(() => data.orders[0].items, [])
          .filter(e => e.pending)
          .map(it => {
            return {
              ...getObjectValue(
                () => JSON.parse(JSON.parse(it.orderJson).modifierJson),
                {}
              ),
              id: it.id,
              pending: true,
            };
          });
        props.pushCartItems(cartItems).then(() => {
          props.history.push({ pathname: `${APP_CONFIG.BASE_URL}/orders` });
        });
      });
    });
  };

  const guestSeatList = [];
  const guestSeats = (guestCount, val = 1) => {
    const obj = {
      number: val,
      tableShareType: 0,
    };
    guestSeatList.push(obj);
    return guestCount > val && guestSeats(guestCount, val + 1);
  };

  const submitSeatNumber = (value, guestCount) => {
    guestSeats(guestCount);
    const dataToSend = {
      deviceId: props.deviceInfo.deviceId,
      employeeId: Number(props.userInfo.id),
      storeId: props.deviceInfo.storeId,
      employeeCard: props.userInfo.employeeCard,
      seats: guestSeatList,
      checkHeaderId: value && value?.id,
    };
    props
      .occupySeat(dataToSend)
      .then(data => {
        props.setSeat({ ...data });
        props.removePosition();
        props.getOrderMenus(props.auth.id).then(() => {
          props.history.replace({ pathname: `${APP_CONFIG.BASE_URL}/orders` });
        });
      })
      .catch(err => {
        props.setNotification({
          type: 'danger',
          message: err.message,
        });
      });
  };

  const openCheck = () => {
    const station = props.auth.stations.find(item => item.number === checkName);
    const dataToSend = {
      deviceId: props.deviceInfo.deviceId,
      employeeId: Number(props.userInfo.id),
      storeId: props.deviceInfo.storeId,
      stationId: (station?.id) || null,
      employeeCard: props.userInfo.employeeCard,
      name: !station ? checkName : null,
      stationGroupId: null,
      isTab: false,
      phoneNumber: null,
      pickupTime: null,
      guestName: null,
      guestCount: 1,
      sourceType: 0,
      delivery: false,
      speedOrder: false,
      orderPay: isOrderPayMode,
    };
    props
      .checkOpen(dataToSend)
      .then(val => {
        window.sessionStorage.removeItem('screenId');
        props.updateChecksAfterResponse(val);
        submitSeatNumber(val, 1);
      })
      .catch(err => {
        props.setNotification({
          type: 'danger',
          message: err.message,
        });
      });
  };
  const lockCallBack = () => {
    props.history.replace(`${APP_CONFIG.BASE_URL}/checkIn?step=1`);
  };

  const sendAll = () => {
    const datatosend = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      checkHeaderId: seat.id,
      employeeCard: props.userInfo.employeeCard,
      items: pendingItems.map(item => {
        return {
          checkOrderItemId: item.id,
        };
      }),
    };
    props
      .sendChecks(datatosend)
      .then(res => {
        props.updateChecksAfterResponse(res);
        props.setSeat({ ...res });
      })
      .catch(err => {
        props.setNotification({
          type: 'danger',
          message: err.message,
        });
      });
  };

  const onClose = type => {
    if (type === 'yes') {
      sendAll();
      setIsConfirmation(false);
    } else {
      setIsConfirmation(false);
    }
  };

  const handleCallServer = () => {
    const station = props.auth.stations.find(item => item.number === checkName);
    const dataToSend = {
      deviceId: props.deviceInfo.deviceId,
      storeId: props.deviceInfo.storeId,
      stationId: (station?.id) || null,
      checkHeaderId: (seat?.id) || null,
    };
    props
      .callServer(dataToSend)
      .then(() => {
        setIsSuccessCallServer(true);
      })
      .catch(err => {
        props.setNotification({
          type: 'danger',
          message: err.message,
        });
      });
  };

  const handleClick = type => {
    switch (type) {
      case 'CallServer':
        handleCallServer();
        break;
      default:
        break;
    }
  };

  return (
    <div className="col-12 p-0 row mx-0 h-100 overflowY position-relative">
      {props.loading && <Loader />}
      <div
        className="position-absolute text-primary od-text-primary"
        style={{
          right: 0,
          top: 0,
          zIndex: '999',
          width: '50px',
          height: '50px',
        }}
        role="presentation"
        onClick={() => handleRouteToCheckListing()}
      />
      <div className="col-12 col-md-5 p-0 h-100">
        <Tiles
          carouselData={tileTypes.filter(e => [7].includes(e.tileType))}
          data={getObjectValue(
            () =>
              tileTypes.filter(
                e =>
                  [4].includes(e.tileType) ||
                  (auth.serverAppFeatures.supportsCallServer &&
                    ['CallServer'].includes(e.link))
              ),
            []
          )}
          onClick={handleClick}
          isSuccessCallServer={isSuccessCallServer}
        />
      </div>
      <div className="col-12 col-md-7 p-1 h-100">
        {pendingItems && pendingItems.length > 0 && !isPaymentMode && (
          <>
            <div
              className={cn(
                'row mx-1 background-secondary od-container-card-background overflowY rounded',
                pendingItems.length > 0 ? 'h-20' : 'd-none'
              )}
            >
              <div className="col-12 text-center fw-600 fs-18 od-text-secondary text-primary">
                {LABEL().UNSENT_ITEMS}
              </div>
              {pendingItems &&
                pendingItems.map(item => {
                  return (
                    <div
                      className={cn(
                        'col-12 px-3 row mx-0 od-text-secondary text-primary',
                        item.isLinked ? 'd-none' : ''
                      )}
                    >
                      <div className="fw-500 col-10 p-0">
                        {item.menuItemName}
                      </div>
                      <div className={cn('col-2 text-right fw-500 p-0')}>
                        {item.quantity}
                      </div>
                      {/* <div className="col-3 fw-500 p-0 text-right">{LABEL().CURRENCY_SYMBOL}{item.price.toFixed(2)}</div> */}
                    </div>
                  );
                })}
            </div>
            <div className="col-12 p-0 row mx-0 h-8 w-100 justify-content-center align-items-center">
              <div className="col-6 px-1">
                <button
                  type="button"
                  className="btn rounded od-btn-primary btn35 btn-primary btn-ripple my-1 w-100"
                  onClick={() =>
                    props.getOrderMenus(props.auth.id).then(() => {
                      goToOrder();
                    })
                  }
                >
                  {LABEL().EDIT_ITEMS}
                </button>
              </div>
              {(isDefaultMode || isOrderOnlyMode) && (
                <div className="col-6 px-1">
                  <button
                    type="button"
                    className="btn rounded od-btn-primary btn35 btn-primary btn-ripple my-1 w-100"
                    onClick={() => setIsConfirmation(true)}
                  >
                    {LABEL().SEND_ALL}
                  </button>
                </div>
              )}
            </div>
          </>
        )}
        <div
          className={cn(
            'row mx-1 background-secondary od-container-card-background rounded',
            pendingItems.length > 0 && !isPaymentMode ? 'h-64' : 'h-92'
          )}
        >
          {!isEmpty(checkHeaderObject) ? (
            <ReceiptScreen
              tableData={{ ...checkHeaderObject }}
              currenySymbol={currenySymbol}
              renderModifier={renderModifier}
              paymentType={1}
              tipAmount={0}
              countryCode={countryCode}
              fontSize={
                pendingItems && pendingItems.length > 0 ? 'fs-22' : 'fs-30'
              }
              noRoundedBorder
            />
          ) : (
            <div className="col-12 h-100 fs-22 od-text-primary text-primary w-100 row mx-0 align-items-center justify-content-center text-uppercase">
              {LABEL().NO_CHECK_AVAILABLE}
            </div>
          )}
        </div>
        <div className="row mx-0 h-8 justify-content-center align-items-end">
          {isEmpty(checkHeaderObject) &&
            (isDefaultMode || isOrderPayMode || isOrderOnlyMode) && (
              <div className="col px-1">
                <button
                  type="button"
                  className="btn rounded od-btn-primary btn35 btn-primary btn-ripple my-1 w-100"
                  onClick={() => openCheck()}
                >
                  {LABEL().START_NEW_ORDER}
                </button>
              </div>
            )}
          {!isEmpty(checkHeaderObject) &&
            (isOrderPayMode || isDefaultMode || isOrderOnlyMode) && (
              <div className="col px-1">
                <button
                  type="button"
                  className="btn rounded od-btn-primary btn35 btn-primary btn-ripple my-1 w-100"
                  onClick={() =>
                    props.getOrderMenus(props.auth.id).then(() => {
                      goToOrder();
                    })
                  }
                >
                  {LABEL().ORDER_ITEMS}
                </button>
              </div>
            )}
          {!isEmpty(checkHeaderObject) &&
            checkHeaderObject.items.length > 0 &&
            !isOrderOnlyMode && (
              <div className="col px-1">
                <button
                  type="button"
                  className="btn rounded od-btn-primary btn35 btn-primary btn-ripple my-1 w-100"
                  onClick={() => {
                    return isOrderPayMode ? speedOrderRouteToPay() : payRoute();
                  }}
                >
                  {LABEL().MAKE_PAYMENT}
                </button>
              </div>
            )}
        </div>
      </div>
      {props.isEmployeeCheck && (
        <EmployeeCheck
          {...props}
          callBack={() => lockCallBack()}
          caseType={flowType()}
        />
      )}
      <KioskConfirmatioPopUp
        isOpen={isConfirmation}
        onClose={onClose}
        type="send all"
        data={pendingItems}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  loading:
    state.tableTop.loading ||
    state.orders.loading ||
    state.checks.loading ||
    state.storeChecks.loading,

  deviceInfo: state.oauth.deviceInformation,
  auth: state.oauth.authInfo,
  seat: state.orders.seats,
  tileTypes: state.tableTop.tileTypes,
  isEmployeeCheck: state.oauth.isEmployeeCheck,
  userInfo: state.oauth.loggedInUserData,

  // keep reference stable — no spreading
  tableData: state.storeChecks.checkListHashTable,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getTableTopTile,
      callServer,
      setNotification,
      openEmployeeCheck,
      setSeat,
      clearCart,
      pushCartItems,
      setPaymentCheck,
      removePaymentCheck,
      clearAuthResponse,
      logout,
      removePosition,
      checkOpen,
      occupySeat,
      updateChecksAfterResponse,
      sendChecks,
      priceCheck,
      updateCheckAfterPriceCheck,
      getOrderMenus,
      setInActivityStatus,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TableTopLandingPage);
